import React, { useEffect, useState } from 'react';
import { Row, Col, Form, Button, Modal } from 'react-bootstrap';
import { PasswordInput } from './components';
import './styles.css';

export interface IFormCompProps {
  fields?: any;
  submitButtonLabel?: string;
  onFormSubmit?(payload: any): void;
  renderSubmitButton?(): void;
  labelColor?: string;
  showModal: boolean;
  handleClose: () => void;
}

export const FormComp = (props: IFormCompProps) => {
  const {
    fields,
    submitButtonLabel,
    onFormSubmit,
    renderSubmitButton,
    showModal,
    handleClose,
  } = props;
  const [formData, updateFormData] = useState<any>({});
  const [validatedsetPassword, setValidatedsetPassword] = useState(false);
  const [errors, setErrors] = useState<any>({});
  const [misPassword, setmisPassword] = useState(false);

  const _renderSubmitButton = (): any => {
    if (renderSubmitButton) {
      return renderSubmitButton();
    }
    return (
      <div className="mt-3 d-flex justify-content-center">
        <Button
          variant="secondary"
          type="submit"
          className="mt-2 animate-up-2"
          style={{
            width: '50%',
            borderRadius: '5px',
            height: '40px',
            fontWeight: 'bold',
          }}
        >
          {submitButtonLabel}
        </Button>
      </div>
    );
  };

  const handleSubmitSetPassword = (e?: any) => {
    const form = e.currentTarget;
    const isValid = form.checkValidity();
    e.preventDefault();
    e.stopPropagation();
    let hasError = false;
    const errorsObj: any = {};
    setValidatedsetPassword(true);
    if (formData?.password !== formData?.confirmpassword) {
      setmisPassword(true);
      errorsObj[fields.confirmpassword.id] = true;
      setErrors(errorsObj);
      hasError = true;
    }
    if (formData?.oldpassword === formData?.password) {
      errorsObj[fields.password.id] =
        'New password must be different from old password';
      hasError = true;
    }
    if (!hasError && isValid) {
      setErrors({});
      setmisPassword(false);
      onFormSubmit && onFormSubmit(formData);
    } else {
      window?.scrollTo(0, 0);
      setErrors(errorsObj);
    }
  };

  const handleCompChange = (id: string, payload: any) => {
    if (id && payload && errors[id]) {
      delete errors[id];
    }
    updateFormData({
      ...formData,
      [id]: payload,
    });
  };

  const _renderSetPassword = () => {
    return (
      <>
        <PasswordInput
          {...fields?.oldpassword}
          value={formData?.oldpassword}
          onCompChange={handleCompChange}
        />
        <PasswordInput
          {...fields?.password}
          value={formData?.password}
          onCompChange={handleCompChange}
          hasError={!!errors[fields?.password?.id]}
          errorText={
            errors[fields?.password?.id] === true
              ? fields?.password?.errorText
              : errors[fields?.password?.id] // show the custom message
          }
        />
        <PasswordInput
          {...fields?.confirmpassword}
          value={formData?.confirmpassword}
          onCompChange={handleCompChange}
          hasError={!!errors[fields?.confirmpassword?.id]}
          errorText={
            errors[fields?.confirmpassword?.id] === true
              ? misPassword
                ? fields?.confirmpassword?.errorText1
                : fields?.confirmpassword?.errorText
              : fields?.confirmpassword?.errorText
          }
        />
      </>
    );
  };

  useEffect(() => {
    console.log(errors);
  }, [errors]);

  return (
    <Modal show={showModal} onHide={handleClose} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Change Password</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form
          noValidate
          validated={validatedsetPassword}
          onSubmit={handleSubmitSetPassword}
        >
          {_renderSetPassword()}
          {_renderSubmitButton()}
        </Form>
      </Modal.Body>
    </Modal>
  );
};

FormComp.defaultProps = {
  fields: {
    oldpassword: {
      id: 'oldpassword',
      label: 'Current Password',
      required: true,
      errorText: 'Current Password is required',
      placeholder: 'Enter your current password',
    },
    password: {
      id: 'password',
      label: 'Password',
      required: true,
      errorText: 'Password is required',
      placeholder: 'Enter your password',
    },
    confirmpassword: {
      id: 'confirmpassword',
      label: 'Confirm Password',
      required: true,
      errorText: 'Password is required',
      errorText1: 'Password mismatched',
      placeholder: 'Confirm your password',
    },
  },
};
